export const maxImageFileSize = 5242880
export const maxImageDimension = 8000
export const env = {
  CONTROL: 'control',
  DESTINATION: 'destination'
}
